import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import flag from '@baseImg/icons/shortcake.webp';

const BG = {
	page: 'Partners',
	brandColor: 'color-brand-orange-400',
	title: '<span class="nowrap">Прави сайтове!</span> <span class="nowrap">Ние ще добавим</span> приходи',
	list: [],
	additionalText: 'Стани наш партньор и ще получаваш комисиона от всеки клиент, когото свържеш с нас, дори след като си приключил проекта.',
	priceServiceId: '',
	priceTerm: 12,
	showMonthly: true,
	textColor: 'white',
	buttonText: 'Стани партньор',
	buttonAction: 'ScrollToTarget',
	buttonParams: ['partners-form'],
	ButtonModal: '',
	infoBar: {
		//text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Ставаме на 21 и растем заедно с AI! Създай своя нов сайт с до 78% отстъпка до 29 октомври!',
		buttonText: 'Поръчай',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	page: 'Partners',
	brandColor: 'color-brand-orange-400',
	title: '<span class="nowrap">Build websites!</span> <span class="nowrap">We will add</span> revenue',
	list: [],
	additionalText: 'Become our partner and earn a commission from every client you refer to us, even after you have completed the project.',
	priceServiceId: '',
	priceTerm: 12,
	showMonthly: true,
	textColor: 'white',
	buttonText: 'Become a partner',
	buttonAction: 'ScrollToTarget',
	buttonParams: ['partners-form'],
	ButtonModal: '',
	infoBar: {
		//text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> We\'re turning 21 and growing together with AI! Create your new website with up to 78% off until Oct. 29!',
		buttonText: 'Order',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];